import { WithdrawalAccountParam } from 'api/types/params';
import { lodash } from 'helpers';

import { WithdrawalAccountsFormType } from '../../forms/withdrawalAccountsForm';

export const getWithdrawalAccountsParam = (
  values: WithdrawalAccountsFormType
): WithdrawalAccountParam[] =>
  lodash.compact(
    values.withdrawalAccounts.map((v) => ({
      bankCountry: v.bankCountry?.id!,
      swiftCode: v.swiftCode,
      bankName: v.bankName,
      bankAddress: v.bankAddress,
      checkingAccount: v.checkingAccount,
      correspondentBankAccountNumber: v.correspondentBankAccountNumber || null,
      correspondentBankSwiftCode: v.correspondentBankSwiftCode || null,
      correspondentBankName: v.correspondentBankName || null,
      ownerConfirmationFileIds: lodash.compact(
        v.ownerConfirmationFiles.map((f) => f.id)
      ),
      currency: v.currency?.value!,
    }))
  );
